// @flow
import React, { Component, ComponentType } from "react";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import SpinnerIcon from "@atlaskit/spinner";

import { event } from "../utils/events";

import { getCustUrl } from "../utils/cust";
import { Title, Text, Form, Buttons, SpinnerWrapper } from "./styled";

type Props = {|
    open: boolean,
    submitState: String,
    onHide: Function,
    Dialog: ComponentType<any>
|};

class Feedback extends Component<Props> {
    constructor(props) {
        super(props);
        this.state = { submitState: props.submitState };
    }

    onClose = () => {
        this.props.onHide();
        this.setState({ submitState: undefined });
    };

    sendFeedback = async () => {
        event({
            category: `Submitting data`,
            action: "Feedback"
        });

        this.setState({ submitState: "submitting" });

        const data = new URLSearchParams();
        data.append("action", "contact");
        data.append("submit", 1);
        data.append("cust_url", getCustUrl());
        data.append("name", "Anonymous User");
        data.append("email", "feedback-form@getjealous.com");
        data.append("subject", "Design Feedback");
        data.append("message", document.getElementById("feedback_textarea").value);

        await fetch("https://www.getjealous.com/knowledge.php?action=contact", {
            method: "POST", // *GET, POST, PUT, DELETE, etc.
            mode: "no-cors", // no-cors, cors, *same-origin
            cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
            credentials: "omit", // include, same-origin, *omit
            body: data // body data type must match "Content-Type" header
        });

        this.setState({ submitState: "submitted" });
    };

    render() {
        const { Dialog, open } = this.props;
        const { submitState } = this.state;
        return (
            <Dialog open={open} showCloseButton={false} onHide={this.onClose}>
                <Form>
                    <Title>Feedback</Title>
                    <Text>
                        We are excited to be launching a new design of GetJealous. We would love to
                        know what you think.
                    </Text>
                    <TextField
                        id="feedback_textarea"
                        label="Your feedback"
                        multiline
                        rowsMax="4"
                        margin="normal"
                    />
                    <Buttons>
                        <Button onClick={this.onClose} variant="contained" color="secondary">
                            Close
                        </Button>
                        {submitState === undefined && (
                            <Button onClick={this.sendFeedback} variant="contained" color="primary">
                                Send Feedback
                            </Button>
                        )}
                        {(submitState === "submitting" || submitState === "submitted") && (
                            <SpinnerWrapper>
                                <SpinnerIcon
                                    size="medium"
                                    isCompleting={submitState === "submitted"}
                                    onComplete={this.onClose}
                                    style={{ backgroundColor: "#000" }}
                                />
                            </SpinnerWrapper>
                        )}
                    </Buttons>
                </Form>
            </Dialog>
        );
    }
}

export default Feedback;



// WEBPACK FOOTER //
// ./src/feedback-dialog/view.js